import { Icon, type IconName } from './components/Icon';
import { useAuth } from './lib/auth';

export interface NavItem { id: string; label: string; icon: IconName }

export const NAV_GROUPS: { title: string; items: NavItem[] }[] = [
  {
    title: 'Operação',
    items: [
      { id: 'dashboard', label: 'Dashboard',         icon: 'home' },
      { id: 'fila',      label: 'A Confirmar',        icon: 'check' },
      { id: 'contas',    label: 'Contas a Pagar',     icon: 'receipt' },
      { id: 'novo',      label: 'Lançamento manual',  icon: 'plus' },
    ],
  },
  {
    title: 'Gestão',
    items: [
      { id: 'guias',        label: 'Guias de Impostos',    icon: 'money' },
      { id: 'fornecedores', label: 'Fornecedores',         icon: 'file' },
      { id: 'extrato',      label: 'Extrato / Conciliação', icon: 'bank' },
      { id: 'aportes',      label: 'Aportes & Aplicações', icon: 'chart' },
      { id: 'relatorios',   label: 'Relatórios',           icon: 'chart' },
    ],
  },
  {
    title: 'Cadastros',
    items: [
      { id: 'plano',  label: 'Plano de Contas',   icon: 'filter' },
      { id: 'bancos', label: 'Contas Bancárias',  icon: 'bank' },
      { id: 'config', label: 'Configurações',     icon: 'cog' },
    ],
  },
];

interface Props {
  page: string;
  navigate: (id: string) => void;
  open: boolean;
  onClose: () => void;
  filaCount?: number;
}

export function Sidebar({ page, navigate, open, onClose, filaCount = 0 }: Props) {
  const { user, logout } = useAuth();
  const iniciais = (user?.nome ?? 'BV')
    .split(/\s+/).map((p) => p[0]).slice(0, 2).join('').toUpperCase();

  return (
    <aside className={`sidebar ${open ? 'open' : ''}`}>
      <div className="brand">
        <img src="/assets/logo.png" alt="" />
        <div>
          <div className="t1">BELA VISTA II</div>
          <div className="t2">Financeiro · SPE</div>
        </div>
      </div>
      <nav className="nav">
        {NAV_GROUPS.map((g) => (
          <div key={g.title}>
            <div className="nav-section">{g.title}</div>
            {g.items.map((n) => (
              <button
                key={n.id}
                className={`nav-item ${page === n.id || (n.id === 'contas' && page === 'detalhe') ? 'active' : ''}`}
                onClick={() => { navigate(n.id); onClose(); }}
              >
                <Icon name={n.icon} className="ic" size={16} />
                <span>{n.label}</span>
                {n.id === 'fila' && filaCount > 0 && <span className="nav-badge">{filaCount}</span>}
              </button>
            ))}
          </div>
        ))}
      </nav>
      <div className="foot">
        <div className="avatar">{iniciais}</div>
        <div className="spacer">
          <div className="n">{user?.nome ?? 'Bela Vista II'}</div>
          <div className="e">{user?.role ?? ''}</div>
        </div>
        <button className="logout" onClick={() => logout()}>Sair</button>
      </div>
    </aside>
  );
}
